export enum NodeType {
  solution = "solution",
  intent = "intent",
  block = "block",
  accordion = "accordion",
  dropdown = "dropdown",
  html = "HTML",
}
